import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import CancelIcon from "@material-ui/icons/Cancel";
import Modal from "react-modal";

const CommonModalInner = ({
  heading,
  subHeading,
  handleCloseButton,
  handleSbmtBtn,
  classes,
  buttontxt,
  heights,
  hDist,
  children,
  createUpdateReminderData,
  binderLetterStatus,
  innerOverflow,
  innerOverflowY,
  isDisabledSbmtBtn,
  hideSbmtBtn,
  bodyFlexDirection,
  backgroundColorBody,
  backgroundColorSbmtBtn,
  buttonTextColor,
  textColor
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        //dispatch(reminderModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, []);
  let buttonColor =  theme.COLORS.secondary_orange;
  if(backgroundColorSbmtBtn){
    buttonColor = backgroundColorSbmtBtn;
  }
  if(isDisabledSbmtBtn){
    buttonColor = "grey"
  }
  return (
    <div className="common-modal-config">
      <div
        style={{
          height: hDist?.headingHeight ? hDist.headingHeight : null ,
          width: "100%",
        }}
      >
        <div
          className="common-modal-config-header"
          style={{
            backgroundColor: theme.COLORS.secondary_skyblue,
            padding:"5px"
          }}
        >
          {heading}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist?.remainingHeight ? hDist?.remainingHeight : "95%",
          backgroundColor: backgroundColorBody ? backgroundColorBody : theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div className="cross-icon-position">
          <CancelIcon
            fontSize="large"
            className="cross-icon-style"
            onClick={handleCloseButton}
          ></CancelIcon>
        </div>

        <div 
          style={{
            display: "flex",
            flexDirection: bodyFlexDirection ? bodyFlexDirection : "column",
            height: "100%", // Ensure it stretches the modal height
            justifyContent: "space-between",
            color: textColor ? textColor : null
          }}
          className="modal-height-align">
         
          <div
            style={{
              width: "100%",
              height: heights?.remainingHeight ? heights.remainingHeight : "88%",
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflowY: innerOverflowY ? innerOverflowY : "auto",
              overflowX:"hidden",
              marginTop: "2%"
              
            }}
            className={classes?.responses}
          >
            {children}
          </div>
          {/* <div className="modal-align"></div> */}
          <div
            className="modal-submit-button"
            style={{
              height: heights?.proceedbutton,
              'display': hideSbmtBtn ? 'none': 'flex',
              backgroundColor: buttonColor,
              width:"20%",
              margin: "4px auto",
              marginBottom:"18px",
              height: "49px",
              cursor: isDisabledSbmtBtn ? "not-allowed" : "pointer",  // Show a "not-allowed" cursor when disabled
              opacity: isDisabledSbmtBtn ? 0.5 : 1,  // Make it look dim when disabled
              color: buttonTextColor ? buttonTextColor : null
              
            }}
            onClick={!isDisabledSbmtBtn ? handleSbmtBtn : null}
          >
            <div>{buttontxt ? buttontxt : "Save"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function CommonModal(props) {
    const {
        openModalBool,
        closeModal,
        modalHeight,
        modalWidth,
    } = props;
    return (
        <Modal
        isOpen={openModalBool}
        ariaHideApp={false}
        disableEscapeKeyDown={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: modalHeight ? modalHeight : "83vh",
            width: modalWidth ? modalWidth : "35vw",
            position: "absolute",
            top: "6vh",
            left: "29vw",
            right: 0,
            bottom: 0,
            background: "white",
            WebkitOverflowScrolling: "touch",
            border: `8px solid white`,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <CommonModalInner
            handleCloseButton={closeModal}
            {...props}
        ></CommonModalInner>
      </Modal>
    )
}

